export default {
  messages: {
    manager: 'ORES is niet de operator die het  distributienet voor elektriciteit en aardgas uitbaat of ORES heeft geen gasdistributienet voor de gekozen plaats. U vindt op <a href=\"http://www.synergrid.be/index.cfm?PageID=16823\" target=\"_blank\">hier</a> de beheerder van het distributienet van uw gemeente.',
    house_number_valid_characters: 'Het huisnummer mag alleen letters, cijfers, spaties, streepjes en schuine strepen bevatten.',
    name_valid_characters: 'De naam bevat verboden tekens. De volgende tekens zijn niet toegestaan: < > \\ : ; " = evenals regeleinden. De sequenties //, /*, */ en -- zijn ook verboden.',
  }
}
